import React, { useState } from "react";

function UploadCsv() {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files) {
      const selectedFile = e.target.files[0];
      if (selectedFile.type === "text/csv") {
        setFile(selectedFile);
      } else {
        alert("Please select a CSV file.");
      }
    }
  };

  const handleUploadClick = () => {
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    fetch("https://httpbin.org/post", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => console.log(data))
      .catch((err) => console.error(err));
  };

  return (
    <div className="mt-4">
      <input
        type="file"
        className="py-2 px-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-indigo-500"
        accept=".csv" // Restrict to CSV files
        onChange={handleFileChange}
      />

      <div className="mt-2">{file && `${file.name} - ${file.type}`}</div>

      <button
        className="mt-2 py-2 px-4 bg-indigo-500 text-white rounded-lg shadow-sm focus:outline-none hover:bg-indigo-600"
        onClick={handleUploadClick}
      >
        Upload
      </button>
    </div>
  );
}

export default UploadCsv;
